import { MenuItemOption, MenuOptionGroup } from "@chakra-ui/react";
import { FundEntityData } from "gen/model/fundEntityData";
import React from "react";
import { useTranslation } from "react-i18next";
import { DropdownButton } from "shared/components/button/DropdownButton";

export interface FundDropdownProps {
  fundId?: string;
  onChangeFundId: (fundId?: string) => void;
  funds?: FundEntityData[];
  canSelectAllFunds?: boolean;
}

/***
@deprecated use FundSelectButton
*/
export const FundDropdown: React.FC<FundDropdownProps> = ({
  fundId,
  onChangeFundId,
  funds,
  canSelectAllFunds = true,
}) => {
  const { t } = useTranslation(["investor"]);

  const isFundSelected = !!fundId;
  const selectedFund =
    isFundSelected && funds
      ? funds.find((fund) => fund.id === fundId)
      : undefined;

  const fundDropdownSelectedText = selectedFund
    ? t("investor:fundDropdown.selected.single", {
        name: selectedFund.legal_name,
      })
    : t("investor:fundDropdown.selected.all");

  // don't show dropdown if there are no funds or only one fund
  if (funds && funds.length <= 1) {
    return null;
  }

  return (
    <DropdownButton
      size="xs"
      colorScheme="secondary"
      title={fundDropdownSelectedText}
    >
      <MenuOptionGroup
        onChange={(value) => {
          onChangeFundId((value as string) || undefined);
        }}
        value={fundId}
      >
        {canSelectAllFunds && (
          <MenuItemOption key="select_all" value="">
            {t("investor:fundDropdown.options.all")}
          </MenuItemOption>
        )}
        {funds?.map((fund) => (
          <MenuItemOption key={`select_${fund.id}`} value={fund.id!}>
            {fund.legal_name}
          </MenuItemOption>
        ))}
      </MenuOptionGroup>
    </DropdownButton>
  );
};
